/**
 * Global object
 * This is used to interface with the window object
 */
export default (() =>
{
    return window as any;
})();